import React, { Component } from "react";
import { Link } from "react-scroll";
import AnyQuestions from "../anyQuestions/anyQuestions";
let hepCenter = React.createRef();
let head = React.createRef();
export class HelpCenter extends Component {
    show(el) {
        el.currentTarget.parentElement.classList.toggle("active");
    }
    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        setTimeout(() => {
            this.props.startPresentPage("other");
            head.current.classList.remove("active");
            head.current.classList.add("active");
        }, 500);
    }
    render() {
        return (
            <>
                <section className="main_content">
                    <div className="block_window help_center" ref={hepCenter}>
                        <h1 className="block_title">Help center</h1>
                        <h2 className="block_title_subtitle">
                            Need help with installing, configuring or using
                            Delibroom? We’d love to help.
                        </h2>

                        <div className="group_category_questions" ref={head}>
                            <Link
                                spy={true}
                                smooth={true}
                                offset={-50}
                                duration={500}
                                to="general"
                                className="col"
                            >
                                <div className="sphere blue">
                                    <div className="waves">
                                        <svg
                                            className="core sphere_general"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="40.343"
                                            height="67.438"
                                            viewBox="0 0 40.343 67.438"
                                        >
                                            <path
                                                id="Rectangle_825_copy_6"
                                                data-name="Rectangle 825 copy 6"
                                                className="cls-1"
                                                d="M452.319,396.456c0-.04,0-0.078,0-0.117l0.006-.167c0-.04,0-0.081.006-0.12s0.007-.105.009-0.157,0.006-.086.01-0.129,0.007-.088.011-0.132,0.007-.086.013-0.128,0.008-.085.013-0.127,0.01-.083.014-0.124,0.011-.083.017-0.124,0.011-.082.017-0.123,0.011-.078.017-0.117,0.014-.083.022-0.124,0.013-.072.019-0.107,0.016-.082.024-0.123,0.013-.068.02-0.1l0.027-.121c0.008-.033.015-0.066,0.022-0.1s0.021-.081.031-0.121l0.024-.093c0.011-.04.022-0.081,0.034-0.121l0.024-.086c0.013-.042.027-0.083,0.04-0.124s0.016-.052.025-0.077c0.015-.048.031-0.094,0.048-0.141,0.006-.018.013-0.037,0.02-0.054,0.012-.034.025-0.068,0.038-0.1s0.023-.062.035-0.092,0.029-.067.042-0.1l0.036-.086c0.014-.032.03-0.063,0.044-0.095s0.026-.057.04-0.085a0.258,0.258,0,0,1,.019-0.037c0.023-.048.046-0.095,0.071-0.141,0.009-.017.019-0.034,0.027-0.051l0.069-.124,0.039-.064,0.063-.1c0.014-.021.027-0.042,0.04-0.063s0.046-.07.07-0.1l0.042-.061c0.028-.038.055-0.076,0.083-0.113,0.015-.019.029-0.038,0.044-0.056,0.031-.041.064-0.08,0.1-0.119,0.011-.013.022-0.026,0.031-0.039,0.049-.055.1-0.108,0.147-0.16l0.034-.036c0.048-.049.1-0.1,0.146-0.142l0.031-.029c0.061-.056.124-0.109,0.188-0.161l0.054-.043,0.072-.055,0.067-.048,0.074-.051,0.057-.039c0.064-.04.127-0.08,0.192-0.118l-9.344,5.372c-0.065.037-.128,0.077-0.192,0.117l-0.022.015-0.036.024-0.074.051-0.066.048-0.072.055c-0.011.01-.024,0.018-0.036,0.028l-0.018.015c-0.064.052-.126,0.105-0.187,0.161l-0.011.008-0.021.021c-0.049.046-.1,0.093-0.145,0.142l-0.023.022-0.012.014c-0.049.052-.1,0.105-0.146,0.161l-0.006.007c-0.009.01-.016,0.021-0.025,0.031-0.034.039-.066,0.079-0.1,0.119-0.006.008-.013,0.014-0.018,0.022l-0.026.034c-0.028.037-.055,0.075-0.082,0.113l-0.026.035c-0.006.008-.011,0.017-0.017,0.026-0.023.033-.047,0.068-0.069,0.1-0.009.015-.021,0.03-0.03,0.045a0.162,0.162,0,0,0-.01.018c-0.022.034-.043,0.069-0.064,0.1-0.01.017-.022,0.035-0.031,0.053a0.067,0.067,0,0,0-.007.011c-0.023.041-.046,0.082-0.068,0.124-0.009.015-.018,0.03-0.026,0.046a0.005,0.005,0,0,0,0,0c-0.024.046-.048,0.094-0.071,0.141l-0.018.036a0,0,0,0,0,0,0c-0.014.028-.026,0.057-0.039,0.085s-0.029.062-.043,0.094a0,0,0,0,1,0,0c-0.013.028-.024,0.057-0.037,0.086s-0.027.065-.04,0.1l0,0-0.034.092c-0.014.033-.026,0.065-0.038,0.1,0,0,0,0,0,0-0.007.017-.013,0.036-0.019,0.053l-0.048.136a0.013,0.013,0,0,1,0,.006c-0.009.025-.017,0.051-0.024,0.076s-0.025.075-.037,0.114l0,0.011-0.024.086c-0.01.035-.021,0.07-0.03,0.106a0.088,0.088,0,0,0,0,.015c-0.008.031-.016,0.062-0.023,0.092s-0.018.067-.027,0.1c0,0.007,0,.014,0,0.021-0.008.032-.014,0.064-0.022,0.1s-0.015.064-.022,0.1l-0.006.026c-0.007.034-.014,0.068-0.02,0.1s-0.012.061-.019,0.092a0.18,0.18,0,0,1-.006.032l-0.018.106c-0.006.029-.011,0.058-0.015,0.088a0.246,0.246,0,0,0-.006.036c-0.006.039-.012,0.078-0.017,0.117s-0.01.057-.013,0.085l-0.006.038c0,0.041-.01.082-0.016,0.123s-0.007.057-.01,0.086c0,0.013,0,.027,0,0.04q-0.006.062-.012,0.126c0,0.029-.006.058-0.01,0.087,0,0.013,0,.028,0,0.041,0,0.044-.008.088-0.012,0.133s0,0.059-.007.089c0,0.013,0,.026,0,0.039,0,0.052-.007.1-0.009,0.157l-0.006.089c0,0.011,0,.021,0,0.031l-0.006.167,0,0.1v0.022c0,0.061,0,.122,0,0.184,0,0.031,0,.062,0,0.093v0.028c0,0.054,0,.107,0,0.16,0,0.013,0,.026,0,0.04l-0.006.123c0,0.012,0,.023,0,0.035,0,0.05-.007.1-0.012,0.148a0.115,0.115,0,0,1,0,.026c0,0.044-.01.088-0.015,0.132l0,0.024c-0.007.047-.014,0.094-0.022,0.14a0.128,0.128,0,0,1,0,.027c-0.008.046-.017,0.091-0.026,0.136a0.146,0.146,0,0,0,0,.02c-0.01.046-.021,0.091-0.033,0.136l0,0.01c-0.012.047-.026,0.092-0.041,0.136a0.014,0.014,0,0,1,0,.006c-0.015.045-.032,0.09-0.049,0.133a0.026,0.026,0,0,0,0,0c-0.017.042-.036,0.084-0.056,0.124a0.021,0.021,0,0,0,0,.006c-0.02.04-.04,0.079-0.061,0.115l-0.006.008a1.112,1.112,0,0,1-.068.105,0.022,0.022,0,0,1,0,.008c-0.024.034-.049,0.066-0.075,0.1l0,0c-0.024.028-.051,0.055-0.078,0.081l-0.011.011a1.069,1.069,0,0,1-.082.069l-0.028.02a0.939,0.939,0,0,1-.087.058l9.344-5.371,0.054-.034c0.012-.007.021-0.016,0.033-0.024a0.283,0.283,0,0,0,.028-0.02,0.1,0.1,0,0,0,.016-0.012c0.02-.016.04-0.033,0.059-0.051a0.017,0.017,0,0,0,.006-0.006l0.013-.011,0.037-.037,0.039-.044,0,0,0,0c0.015-.017.029-0.035,0.043-0.053l0.03-.041a0.035,0.035,0,0,0,0-.008l0-.006c0.013-.018.025-0.036,0.037-0.055l0.026-.044a0.022,0.022,0,0,0,0-.008l0,0c0.011-.02.023-0.039,0.033-0.059s0.016-.034.025-0.051a0.011,0.011,0,0,0,0-.006l0,0c0.009-.02.019-0.041,0.028-0.063a0.589,0.589,0,0,0,.024-0.058l0,0a0.01,0.01,0,0,1,0,0l0.027-.068,0.021-.062s0,0,0-.006l0,0c0.007-.025.015-0.05,0.023-0.075s0.012-.039.017-0.059l0-.01a0.014,0.014,0,0,1,0-.006c0.006-.027.013-0.054,0.02-0.081a0.485,0.485,0,0,0,.011-0.049,0.146,0.146,0,0,0,0-.02,0.124,0.124,0,0,1,0-.016c0.006-.028.011-0.057,0.018-0.087,0-.011,0-0.022,0-0.033s0-.018,0-0.027l0.006-.033c0.006-.031.01-0.063,0.014-0.095a0.069,0.069,0,0,1,0-.013l0-.023c0-.022.006-0.045,0.008-0.067s0-.043.007-0.065l0-.026a0.071,0.071,0,0,1,0-.014c0-.037.006-0.075,0.009-0.113a0.149,0.149,0,0,0,0-.021c0-.012,0-0.023,0-0.035s0-.04,0-0.06,0-.042,0-0.063,0-.027,0-0.04a0.148,0.148,0,0,0,0-.021c0-.042,0-0.085,0-0.127v-0.012c0-.041,0-0.081,0-0.121C452.317,396.578,452.318,396.516,452.319,396.456Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_8"
                                                data-name="Rectangle 825 copy 8"
                                                className="cls-1"
                                                d="M465.6,414.949a8.464,8.464,0,0,1-1.309.442q-0.269.1-.526,0.2t-0.506.217c-0.082.038-.164,0.076-0.244,0.115-0.243.117-.477,0.241-0.7,0.371l-9.344,5.371a12.241,12.241,0,0,1,1.981-.9,8.537,8.537,0,0,0,1.309-.442,15.908,15.908,0,0,0,3.9-1.377l9.344-5.371A15.931,15.931,0,0,1,465.6,414.949Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_5"
                                                data-name="Rectangle 825 copy 5"
                                                className="cls-2"
                                                d="M453.273,391.225c8.355,4.771,15.211,15.127,15.183,25.018-0.025,8.507-4.3,9.732-9.272,11.054l-0.958.343c-3.753,1.127-4.893,3.449-4.908,8.79v0.4c-0.006,1.879-.011,3.956-2.709,2.415a5.583,5.583,0,0,1-2.774-5.25l0-.692c0.02-7.122,2.3-10.776,7.1-12.493a8.646,8.646,0,0,0,1.309-.442c3.576-.929,6.717-1.811,6.732-7.153,0.018-6.33-4.409-12.722-9.805-15.8-5.743-3.28-10.192-1.858-10.212,4.769,0,1.583-.619,3.015-2.62,1.873a5.78,5.78,0,0,1-2.863-4.608C437.5,388.956,444.049,385.957,453.273,391.225Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_10"
                                                data-name="Rectangle 825 copy 10"
                                                className="cls-2"
                                                d="M450.44,442.363a7.426,7.426,0,0,1,3.469,5.945c-0.006,1.977-1.491,3.111-3.492,1.968a8.251,8.251,0,0,1-3.47-5.945C446.953,442.155,448.7,441.369,450.44,442.363Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_9"
                                                data-name="Rectangle 825 copy 9"
                                                className="cls-1"
                                                d="M463.252,442.84c0-.036,0-0.071,0-0.107h0a0,0,0,0,0,0,0c0-.036,0-0.07,0-0.105l-0.006-.09c0-.005,0-0.011,0-0.016a0.038,0.038,0,0,0,0-.01c0-.039-0.007-0.078-0.01-0.118,0-.019,0-0.039-0.007-0.059s0-.021,0-0.031,0-.019,0-0.028c0-.045-0.011-0.09-0.018-0.134,0-.008,0-0.016,0-0.023s0-.024,0-0.037L463.172,442c-0.006-.028-0.011-0.057-0.016-0.085s0-.027-0.008-0.041,0-.013,0-0.02c-0.01-.053-0.022-0.106-0.033-0.159l0-.012c0-.016-0.007-0.032-0.011-0.048l-0.027-.113-0.009-.033c-0.008-.03-0.015-0.061-0.024-0.091s-0.014-.051-0.02-0.076-0.008-.023-0.011-0.034c-0.014-.051-0.03-0.1-0.046-0.152-0.006-.02-0.012-0.041-0.019-0.061a0.044,0.044,0,0,0,0-.015c-0.032-.1-0.069-0.2-0.106-0.3,0-.01-0.007-0.02-0.009-0.03s-0.015-.035-0.022-0.053c-0.017-.045-0.035-0.089-0.053-0.134l-0.039-.093c-0.02-.045-0.039-0.09-0.058-0.135l-0.042-.09c-0.021-.047-0.044-0.093-0.066-0.14-0.013-.027-0.026-0.055-0.041-0.082-0.025-.054-0.053-0.107-0.082-0.161l-0.026-.052a0.01,0.01,0,0,1,0,0c-0.051-.1-0.106-0.191-0.161-0.285-0.006-.011-0.012-0.022-0.019-0.033l-0.024-.039L462.1,439.3c-0.012-.018-0.022-0.036-0.034-0.054l-0.021-.032L462,439.136c-0.014-.022-0.029-0.043-0.044-0.065s-0.022-.032-0.032-0.048l-0.046-.065-0.031-.045-0.064-.088-0.024-.032-0.008-.012-0.1-.129-0.018-.023-0.024-.03c-0.014-.018-0.029-0.037-0.045-0.055-0.027-.035-0.056-0.068-0.083-0.1a0.015,0.015,0,0,1,0,0h0c-0.029-.034-0.057-0.068-0.086-0.1l-0.051-.058c-0.006-.007-0.012-0.013-0.017-0.02l-0.013-.014c-0.027-.031-0.056-0.061-0.083-0.09l-0.042-.045-0.02-.021-0.02-.021-0.078-.08q-0.023-.021-0.042-0.042L461,437.927l-0.019-.019-0.08-.077-0.048-.044-0.015-.014-0.015-.014-0.078-.07-0.062-.054a0.106,0.106,0,0,0-.011-0.009l-0.008-.007-0.078-.066-0.08-.065s0,0,0,0h0c-0.026-.021-0.051-0.041-0.078-0.061l-0.081-.062-0.011-.008-0.013-.009-0.059-.043c-0.027-.02-0.055-0.04-0.084-0.059l-0.021-.015-0.017-.012-0.046-.031-0.088-.057-0.029-.018-0.021-.014-0.039-.024-0.09-.054-0.046-.026-0.037-.021-0.074-.041-0.049-.024-0.012-.007-0.014-.007-0.075-.036-0.067-.031-0.011,0-0.007,0q-0.043-.02-0.087-0.036l-0.062-.024-0.013,0-0.009,0c-0.034-.013-0.067-0.025-0.1-0.036l-0.036-.011-0.031-.01-0.034-.011q-0.056-.017-0.111-0.03h0l-0.015,0c-0.036-.009-0.072-0.018-0.107-0.025l-0.025,0-0.056-.01-0.057-.01-0.033,0-0.08-.01-0.047-.006h-0.024c-0.059,0-.118-0.007-0.176-0.008h-0.05c-0.038,0-.075,0-0.112,0l-0.051,0-0.091.01-0.056.009-0.083.015-0.055.012-0.08.02-0.054.016-0.08.027-0.049.018c-0.029.011-.056,0.024-0.085,0.036-0.012.007-.026,0.012-0.039,0.018-0.042.02-.081,0.041-0.12,0.063l-9.344,5.371c0.04-.022.078-0.043,0.12-0.063l0.04-.018c0.028-.012.055-0.025,0.084-0.036l0.05-.018,0.079-.027,0.054-.015c0.026-.008.054-0.015,0.08-0.021l0.056-.012c0.027-.006.055-0.011,0.083-0.015l0.055-.009,0.091-.01,0.05,0c0.037,0,.075,0,0.113,0h0.051c0.058,0,.116,0,0.175.008l0.071,0.007,0.081,0.01,0.09,0.014,0.055,0.01c0.045,0.009.088,0.019,0.132,0.03l0.015,0,0.147,0.042,0.031,0.01c0.048,0.016.1,0.032,0.146,0.051l0.014,0c0.051,0.02.1,0.041,0.154,0.063l0.011,0.005c0.052,0.024.1,0.048,0.155,0.074a0.047,0.047,0,0,1,.012.007c0.055,0.027.108,0.055,0.162,0.086s0.116,0.068.174,0.105a0.239,0.239,0,0,1,.021.013c0.054,0.034.11,0.07,0.163,0.106l0.018,0.012c0.054,0.038.109,0.077,0.163,0.117l0.014,0.009c0.056,0.043.113,0.086,0.168,0.131l0,0c0.056,0.045.113,0.092,0.168,0.139l0.009,0.009q0.079,0.067.156,0.138a0.1,0.1,0,0,1,.015.014c0.05,0.046.1,0.093,0.148,0.14l0.017,0.018c0.048,0.047.095,0.1,0.141,0.143a0.194,0.194,0,0,1,.02.021c0.047,0.049.093,0.1,0.137,0.15l0.018,0.018,0.139,0.161a0.005,0.005,0,0,0,0,0c0.043,0.052.086,0.105,0.128,0.158L452.287,444c0.042,0.055.085,0.109,0.125,0.164,0.008,0.011.016,0.021,0.023,0.032,0.033,0.044.065,0.088,0.1,0.133,0.015,0.022.03,0.044,0.046,0.065l0.076,0.113,0.048,0.073c0.019,0.028.037,0.057,0.055,0.086,0.028,0.045.057,0.09,0.084,0.136,0.014,0.024.029,0.048,0.042,0.072,0.057,0.094.112,0.189,0.163,0.285,0.01,0.019.019,0.038,0.03,0.056,0.027,0.054.055,0.108,0.083,0.162l0.039,0.082c0.022,0.046.045,0.093,0.067,0.14,0.014,0.03.028,0.06,0.041,0.09l0.058,0.135,0.04,0.093c0.017,0.045.035,0.09,0.053,0.135,0.01,0.027.021,0.054,0.031,0.082,0.038,0.1.073,0.2,0.106,0.3,0.008,0.025.016,0.051,0.023,0.077,0.017,0.05.032,0.1,0.047,0.151l0.03,0.11c0.009,0.03.017,0.061,0.025,0.091,0.012,0.049.024,0.1,0.035,0.146l0.012,0.048c0.014,0.064.027,0.127,0.039,0.191a0.3,0.3,0,0,1,.008.041c0.01,0.054.019,0.107,0.027,0.161,0,0.012,0,.024.006,0.036,0.01,0.062.018,0.123,0.025,0.185,0,0.011,0,.021,0,0.032,0.007,0.062.013,0.124,0.017,0.186,0,0,0,.011,0,0.017,0,0.064.008,0.129,0.012,0.193v0c0,0.068,0,.137,0,0.2s0,0.123,0,.184a0.034,0.034,0,0,1,0,.01q0,0.086-.012.168a0.1,0.1,0,0,0,0,.017c-0.006.054-.012,0.107-0.02,0.159l0,0.015c-0.009.053-.019,0.107-0.029,0.159,0,0,0,0,0,.008-0.011.054-.025,0.108-0.04,0.16v0c-0.014.052-.03,0.1-0.046,0.152a0.029,0.029,0,0,0,0,.01c-0.018.048-.034,0.094-0.053,0.14a0.026,0.026,0,0,0,0,.01c-0.019.047-.039,0.092-0.061,0.136a0.008,0.008,0,0,1,0,0c-0.02.042-.041,0.083-0.064,0.123l-0.008.014c-0.022.038-.045,0.075-0.069,0.112l-0.016.024c-0.025.036-.049,0.071-0.076,0.105l-0.01.012c-0.023.031-.048,0.06-0.074,0.089l-0.024.027-0.064.066-0.034.033c-0.022.021-.046,0.042-0.069,0.061s-0.021.019-.032,0.028l-0.042.031c-0.026.02-.051,0.039-0.079,0.057s-0.07.047-.107,0.068l9.344-5.371c0.033-.019.065-0.039,0.1-0.06l0.01-.008c0.027-.018.053-0.038,0.079-0.057l0.035-.026,0.006-.006,0.033-.027c0.018-.016.038-0.031,0.056-0.048l0.013-.013,0.034-.033,0.04-.039,0.023-.027,0.025-.027c0.007-.008.014-0.015,0.02-0.023s0.036-.043.054-0.066l0.01-.012s0,0,0,0c0.019-.025.038-0.049,0.055-0.075,0.006-.009.013-0.018,0.019-0.028l0.016-.023c0.006-.009.012-0.018,0.017-0.027,0.016-.025.032-0.05,0.046-0.077l0.006-.008a0.059,0.059,0,0,0,.006-0.014c0.011-.017.021-0.035,0.03-0.052s0.024-.047.036-0.071a0.008,0.008,0,0,0,0-.005h0q0.02-.037.036-0.075c0.009-.02.016-0.039,0.024-0.059,0,0,0-.007,0-0.01s0,0,0-.006c0.01-.025.021-0.051,0.029-0.076s0.015-.039.021-0.058a0.045,0.045,0,0,0,0-.011l0-.006,0.024-.075c0.007-.023.013-0.046,0.02-0.07,0,0,0,0,0,0v0c0.007-.026.014-0.051,0.02-0.077l0.018-.076a0.011,0.011,0,0,1,0,0,0.019,0.019,0,0,1,0-.008c0-.021.008-0.042,0.012-0.063s0.01-.052.014-0.078l0-.018s0-.01,0-0.015a0.35,0.35,0,0,0,.007-0.045c0-.026.008-0.052,0.01-0.078s0-.024,0-0.036V443.3a0.251,0.251,0,0,0,0-.027c0-.026,0-0.053.007-0.08l0-.061s0-.007,0-0.01v-0.01c0-.028,0-0.055,0-0.083v-0.091C463.253,442.9,463.252,442.872,463.252,442.84Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_7"
                                                data-name="Rectangle 825 copy 7"
                                                className="cls-1"
                                                d="M456.417,428.355l-0.195.118-0.06.038-0.087.056-0.036.026-0.1.066-0.1.071-0.092.07-0.059.045c-0.015.012-.028,0.024-0.043,0.035l-0.057.048c-0.04.032-.078,0.065-0.115,0.1l-0.049.043-0.019.017c-0.011.01-.021,0.022-0.032,0.032-0.056.052-.111,0.106-0.164,0.161l-0.033.032c-0.01.01-.019,0.021-0.028,0.032-0.038.04-.074,0.08-0.11,0.121l-0.044.048-0.017.022c-0.034.04-.066,0.081-0.1,0.122-0.014.019-.031,0.037-0.045,0.056a0.067,0.067,0,0,1-.011.014c-0.025.033-.049,0.067-0.074,0.1s-0.038.051-.056,0.077l-0.008.013c-0.02.028-.039,0.058-0.058,0.087s-0.041.06-.06,0.091c0,0-.007.011-0.011,0.017-0.016.025-.032,0.051-0.047,0.077s-0.037.061-.056,0.093l-0.015.027-0.045.082-0.046.082-0.02.04c-0.013.027-.028,0.054-0.041,0.082l-0.035.067-0.027.06-0.039.085-0.023.051c-0.012.028-.025,0.057-0.036,0.086s-0.023.052-.034,0.079a0.309,0.309,0,0,1-.014.032c-0.017.043-.033,0.087-0.05,0.13-0.007.021-.015,0.041-0.023,0.062l0,0.012c-0.025.07-.05,0.141-0.074,0.212a0.064,0.064,0,0,1,0,.007,0.364,0.364,0,0,0-.014.047c-0.019.054-.037,0.109-0.053,0.165a0.147,0.147,0,0,0-.008.028l-0.027.091c-0.01.037-.021,0.074-0.031,0.112,0,0.016-.008.031-0.012,0.047-0.01.035-.018,0.071-0.027,0.107s-0.016.059-.023,0.09-0.011.042-.015,0.064c-0.01.038-.018,0.077-0.028,0.116s-0.011.05-.016,0.076-0.01.051-.015,0.076c-0.01.045-.019,0.089-0.028,0.134,0,0.022-.009.044-0.014,0.067s-0.009.056-.014,0.084c-0.009.048-.018,0.1-0.026,0.144,0,0.022-.007.044-0.011,0.066s-0.008.055-.013,0.083c-0.008.056-.018,0.114-0.025,0.171,0,0.024-.008.047-0.011,0.071s-0.007.05-.01,0.075c-0.009.064-.016,0.129-0.024,0.194,0,0.028-.008.055-0.011,0.083l-0.006.061c-0.009.079-.017,0.159-0.025,0.24,0,0.031-.006.06-0.01,0.091l0,0.034c-0.012.133-.023,0.268-0.032,0.4,0,0,0,.006,0,0.009-0.007.1-.013,0.2-0.019,0.3,0,0.028,0,.057,0,0.085s0,0.076-.006.114,0,0.09-.006.134,0,0.07,0,.106c0,0.107-.007.216-0.01,0.326,0,0.006,0,.012,0,0.017v0c0,0.122-.006.246-0.008,0.371v0.125c0,0.074,0,.148,0,0.224v0.068l0,0.4v0.159c0,0.181,0,.362-0.007.541a0.081,0.081,0,0,1,0,.016c0,0.084,0,.167-0.008.249v0.016c0,0.061-.007.121-0.01,0.18l0,0.027c0,0.047-.007.095-0.011,0.141l0,0.032-0.009.09c0,0.013,0,.027,0,0.04s-0.006.05-.01,0.074,0,0.026,0,.039-0.006.039-.01,0.059,0,0.028-.006.042-0.005.03-.008,0.044l-0.009.05a0.329,0.329,0,0,1-.009.043c0,0.017-.007.033-0.009,0.049s0,0.02-.007.029-0.009.037-.014,0.055a0.163,0.163,0,0,1-.007.03c0,0.018-.009.036-0.015,0.054a0.129,0.129,0,0,1-.008.026c-0.007.025-.015,0.05-0.022,0.074a0.042,0.042,0,0,1,0,.01c-0.007.021-.014,0.042-0.022,0.063,0,0.006,0,.013-0.008.02s-0.015.039-.024,0.058a0.076,0.076,0,0,0,0,.011l-0.03.064-0.008.016-0.029.054a0.024,0.024,0,0,1-.006.009c-0.01.02-.022,0.039-0.034,0.058l-0.011.015c-0.009.015-.02,0.03-0.03,0.045a0.048,0.048,0,0,0-.009.011l-0.041.051-0.013.014c-0.011.012-.021,0.023-0.033,0.034l-0.016.017-0.034.03a0.13,0.13,0,0,1-.018.015l-0.025.02-0.038.027a0.519,0.519,0,0,1-.05.031l9.344-5.371,0.04-.024,0.01-.007,0.037-.027,0.018-.013,0.008-.007,0.017-.015,0.02-.016,0.014-.014a0.137,0.137,0,0,0,.017-0.017,0.057,0.057,0,0,0,.011-0.011l0.023-.023a0.079,0.079,0,0,1,.012-0.015l0,0c0.012-.013.022-0.026,0.033-0.04l0,0a0.1,0.1,0,0,1,.008-0.011l0.019-.025a0.239,0.239,0,0,1,.013-0.021l0.009-.014,0.006-.009q0.015-.022.027-0.045a0.005,0.005,0,0,0,0,0,0.021,0.021,0,0,0,.006-0.01,0.2,0.2,0,0,0,.018-0.032l0.011-.021,0.008-.016a0.03,0.03,0,0,1,.006-0.011l0.022-.049a0.015,0.015,0,0,1,0,0,0.049,0.049,0,0,1,0-.011l0.016-.039a0.154,0.154,0,0,0,.008-0.019,0.18,0.18,0,0,1,.008-0.021l0.006-.017c0-.015.01-0.03,0.016-0.045l0-.01,0,0c0.006-.02.012-0.04,0.019-0.06a0.036,0.036,0,0,1,0-.011c0-.009,0-0.018.008-0.026l0.009-.033c0-.007,0-0.015.006-0.021s0-.02.007-0.03a0.08,0.08,0,0,0,0-.021,0.151,0.151,0,0,0,.008-0.034c0-.01,0-0.019.007-0.029l0-.012c0-.012,0-0.025.007-0.037s0.006-.029.009-0.043a0.036,0.036,0,0,0,0-.01,0.283,0.283,0,0,1,.008-0.04,0.335,0.335,0,0,1,.007-0.044s0-.006,0-0.008,0-.023,0-0.034,0.006-.039.01-0.06c0,0,0-.007,0-0.011l0-.027c0-.025.007-0.049,0.01-0.075a0.11,0.11,0,0,0,0-.018c0-.007,0-0.014,0-0.022,0-.029.007-0.059,0.009-0.089l0-.023a0.028,0.028,0,0,0,0-.009c0-.047.008-0.094,0.011-0.141,0,0,0-.007,0-0.011a0.086,0.086,0,0,0,0-.016c0-.059.008-0.119,0.01-0.18v-0.006s0-.007,0-0.01c0-.082.006-0.165,0.009-0.249v-0.016c0-.179.006-0.36,0.006-0.541v0c0-.007,0-0.015,0-0.023v-0.133l0-.4c0-.1,0-0.195,0-0.292,0-.041,0-0.084,0-0.125,0-.126,0-0.251.007-0.374,0,0,0-.011,0-0.017,0-.11.006-0.219,0.011-0.326,0-.036,0-0.071,0-0.107,0-.083.007-0.166,0.012-0.247,0-.028,0-0.057,0-0.085,0-.105.012-0.209,0.019-0.312,0.01-.138.022-0.272,0.033-0.4l0.012-.125c0.008-.081.016-0.162,0.025-0.24,0-.049.012-0.1,0.017-0.144,0.009-.065.016-0.13,0.025-0.194,0.007-.049.013-0.1,0.02-0.146s0.018-.115.026-0.172,0.016-.1.024-0.148,0.017-.1.026-0.144,0.018-.1.028-0.152l0.027-.133c0.011-.051.021-0.1,0.033-0.152s0.018-.078.026-0.117,0.025-.1.038-0.153,0.018-.072.028-0.107c0.013-.054.029-0.107,0.044-0.159,0.008-.031.017-0.061,0.025-0.091,0.02-.066.04-0.13,0.061-0.194,0-.015.009-0.031,0.014-0.046,0.027-.079.054-0.156,0.082-0.231l0.023-.062q0.032-.083.063-0.162c0.011-.027.023-0.053,0.034-0.079,0.02-.046.039-0.092,0.06-0.137,0.012-.029.025-0.057,0.038-0.085l0.063-.128c0.013-.027.027-0.054,0.041-0.081s0.043-.082.066-0.123,0.03-.054.046-0.081,0.046-.08.07-0.12,0.031-.052.048-0.078,0.046-.071.069-0.107,0.038-.059.059-0.087,0.043-.06.064-0.09,0.049-.068.075-0.1,0.037-.047.056-0.07c0.031-.041.065-0.082,0.1-0.122,0.019-.024.04-0.047,0.061-0.07,0.035-.041.072-0.081,0.109-0.121l0.061-.065c0.054-.054.108-0.107,0.164-0.16l0.053-.05,0.047-.042,0.116-.1,0.056-.047,0.1-.08,0.09-.07,0.1-.071,0.1-.066,0.124-.082,0.06-.038c0.064-.04.129-0.079,0.2-0.118Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_4"
                                                data-name="Rectangle 825 copy 4"
                                                className="cls-1"
                                                d="M442.116,389.3l0.073-.034c0.085-.038.168-0.074,0.254-0.108h0c0.085-.034.171-0.065,0.258-0.1l0.078-.027c0.066-.022.131-0.043,0.2-0.063l0.079-.025c0.09-.026.181-0.051,0.272-0.074h0c0.091-.023.184-0.044,0.276-0.063l0.084-.017,0.211-.038,0.084-.014c0.1-.015.192-0.029,0.29-0.04h0c0.1-.011.2-0.021,0.293-0.029l0.089-.006c0.074-.006.149-0.01,0.224-0.014l0.089,0c0.1,0,.2-0.006.308-0.006h0c0.1,0,.2,0,0.307,0l0.073,0c0.1,0,.207.009,0.311,0.016l0.037,0c0.084,0.006.169,0.014,0.253,0.022,0.066,0.006.133,0.013,0.2,0.021s0.117,0.013.175,0.021,0.135,0.018.2,0.028,0.126,0.018.188,0.029c0.043,0.006.086,0.014,0.128,0.021l0.227,0.042c0.043,0.008.086,0.016,0.13,0.026,0.083,0.016.167,0.035,0.253,0.053l0.1,0.022c0.119,0.028.238,0.056,0.357,0.087l0.043,0.012c0.1,0.027.207,0.055,0.311,0.085l0.1,0.029,0.3,0.09,0.062,0.019c0.12,0.038.24,0.078,0.362,0.119l0.076,0.027c0.107,0.037.215,0.075,0.322,0.115l0.055,0.02c0.12,0.044.242,0.091,0.363,0.139l0.085,0.034c0.12,0.048.241,0.1,0.363,0.149l0.01,0c0.111,0.046.222,0.1,0.333,0.145s0.234,0.1.351,0.159l0.132,0.062q0.241,0.114.484,0.235c0.034,0.016.067,0.034,0.1,0.05,0.128,0.065.255,0.13,0.385,0.2l0.169,0.091c0.107,0.057.214,0.115,0.32,0.174S453.886,391.935,454,392l10-5c-0.086-.049-1.54-1.287-1.626-1.335l-0.082-.044c-0.107-.059-0.213-0.117-0.32-0.174l-0.122-.067-0.048-.024c-0.128-.068-0.257-0.134-0.383-0.2l-0.087-.044-0.012-.006c-0.162-.081-0.325-0.16-0.485-0.235l-0.028-.014-0.105-.048c-0.117-.054-0.234-0.108-0.35-0.159l-0.067-.03-0.266-.115-0.011,0-0.248-.1c-0.037-.016-0.076-0.031-0.114-0.046l-0.085-.034c-0.114-.045-0.227-0.089-0.339-0.13l-0.024-.01-0.055-.019c-0.108-.04-0.215-0.078-0.321-0.115l-0.078-.027L458.692,384c-0.1-.035-0.206-0.068-0.309-0.1l-0.062-.019-0.2-.062-0.1-.028-0.1-.029c-0.105-.03-0.208-0.058-0.31-0.085l-0.044-.012-0.013,0c-0.115-.029-0.229-0.057-0.344-0.084l-0.1-.022-0.181-.04-0.072-.014-0.128-.025c-0.077-.015-0.152-0.029-0.228-0.042l-0.128-.021L456.3,383.4l-0.116-.016c-0.067-.01-0.135-0.02-0.2-0.028s-0.117-.015-0.175-0.021l-0.2-.021-0.073-.008-0.18-.014-0.037,0c-0.105-.007-0.208-0.012-0.312-0.016l-0.072,0c-0.1,0-.206,0-0.307,0h0c-0.1,0-.2,0-0.307.006l-0.089,0c-0.075,0-.15.008-0.224,0.013l-0.089.007c-0.1.008-.2,0.017-0.293,0.029h0c-0.1.012-.195,0.026-0.291,0.041l-0.084.014-0.212.038-0.083.017q-0.139.029-.276,0.063h0c-0.091.023-.181,0.048-0.271,0.074l-0.08.025c-0.066.02-.132,0.041-0.2,0.063l-0.078.026c-0.087.031-.174,0.063-0.259,0.1h0c-0.086.035-.171,0.071-0.253,0.109l-0.075.034c-0.061.028-.122,0.058-0.182,0.088l-0.073.037c-0.081.042-.161,0.085-0.24,0.131l-9.344,5.371c0.079-.046.16-0.089,0.24-0.131l0.073-.037C441.993,389.356,442.054,389.327,442.116,389.3Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_3"
                                                data-name="Rectangle 825 copy 3"
                                                className="cls-1"
                                                d="M477.815,410.876v-0.047c0-.142,0-0.283,0-0.424,0-.007,0-0.013,0-0.02q0-.12-0.006-0.24c0-.069,0-0.138-0.006-0.207v-0.019c0-.08-0.008-0.161-0.013-0.241l-0.009-.207c0-.006,0-0.012,0-0.018-0.007-.122-0.016-0.245-0.026-0.368,0-.035,0-0.07-0.007-0.1v-0.006c-0.013-.161-0.029-0.322-0.045-0.482a0.049,0.049,0,0,1,0-.012c0-.042-0.009-0.085-0.015-0.128-0.013-.115-0.025-0.229-0.038-0.343a0.236,0.236,0,0,1,0-.028c0-.04-0.011-0.081-0.017-0.121-0.016-.121-0.031-0.241-0.049-0.362,0-.02,0-0.039-0.008-0.059-0.006-.041-0.014-0.083-0.02-0.124q-0.025-.17-0.054-0.339l-0.015-.095c-0.006-.033-0.012-0.065-0.019-0.1-0.019-.116-0.041-0.232-0.063-0.348-0.008-.039-0.014-0.079-0.022-0.119,0-.018-0.008-0.035-0.011-0.053-0.039-.195-0.079-0.39-0.122-0.584l-0.006-.025-0.018-.077c-0.037-.166-0.077-0.331-0.118-0.5-0.007-.029-0.013-0.058-0.02-0.087s-0.019-.074-0.03-0.111c-0.015-.062-0.031-0.123-0.047-0.184l-0.069-.259c-0.017-.06-0.033-0.12-0.051-0.181-0.007-.029-0.015-0.059-0.024-0.088q-0.021-.077-0.045-0.153l-0.064-.22-0.072-.234c-0.023-.073-0.045-0.147-0.069-0.219-0.007-.025-0.015-0.05-0.023-0.074s-0.021-.064-0.032-0.1c-0.049-.15-0.1-0.3-0.15-0.449-0.016-.048-0.032-0.1-0.05-0.144-0.066-.188-0.133-0.376-0.2-0.563a0.113,0.113,0,0,0-.008-0.024c-0.019-.053-0.04-0.1-0.06-0.158l-0.107-.279-0.08-.2c-0.035-.089-0.071-0.178-0.107-0.267l-0.085-.2c-0.037-.087-0.073-0.174-0.11-0.259-0.029-.069-0.059-0.138-0.09-0.206l-0.112-.253c-0.031-.069-0.063-0.138-0.1-0.207s-0.076-.166-0.116-0.249-0.064-.138-0.1-0.206c-0.039-.083-0.079-0.165-0.12-0.248s-0.068-.137-0.1-0.205l-0.124-.245c-0.035-.068-0.069-0.136-0.105-0.2s-0.085-.163-0.129-0.244c-0.022-.043-0.044-0.085-0.067-0.127a0.586,0.586,0,0,0-.03-0.055q-0.155-.288-0.315-0.573c-0.019-.033-0.037-0.066-0.057-0.1q-0.142-.252-0.291-0.5c-0.016-.026-0.03-0.052-0.045-0.077l-0.034-.056-0.165-.271c-0.034-.057-0.068-0.113-0.1-0.169-0.062-.1-0.127-0.2-0.191-0.3-0.025-.038-0.048-0.077-0.073-0.116L473.115,396l-0.085-.132c-0.058-.088-0.114-0.175-0.172-0.262l-0.1-.155-0.125-.185-0.024-.034c-0.126-.185-0.253-0.367-0.382-0.549-0.012-.016-0.023-0.031-0.033-0.047l-0.056-.075c-0.106-.149-0.215-0.3-0.323-0.444l-0.05-.067-0.021-.028c-0.119-.158-0.238-0.315-0.36-0.471l-0.023-.03c-0.023-.03-0.047-0.059-0.071-0.088-0.086-.111-0.174-0.222-0.261-0.332-0.02-.023-0.038-0.048-0.058-0.071l-0.063-.076-0.255-.31c-0.026-.03-0.051-0.061-0.075-0.091l-0.035-.041c-0.087-.1-0.175-0.2-0.263-0.308l-0.071-.082-0.012-.013c-0.115-.132-0.231-0.264-0.35-0.4,0,0-.008-0.01-0.012-0.015-0.028-.031-0.056-0.061-0.085-0.091-0.084-.093-0.168-0.185-0.253-0.277-0.011-.012-0.022-0.025-0.034-0.037q-0.052-.057-0.1-0.111c-0.07-.074-0.138-0.147-0.208-0.22l-0.051-.053c-0.032-.034-0.065-0.067-0.1-0.1l-0.2-.209-0.067-.067-0.09-.09-0.2-.195-0.079-.079c-0.026-.026-0.054-0.052-0.082-0.078-0.063-.062-0.128-0.123-0.192-0.184L468,389.824c-0.024-.023-0.048-0.046-0.073-0.068l-0.195-.182-0.1-.093-0.065-.058c-0.065-.059-0.13-0.118-0.2-0.177-0.036-.032-0.072-0.066-0.109-0.1-0.018-.017-0.038-0.033-0.057-0.05l-0.2-.171c-0.04-.034-0.078-0.069-0.117-0.1l-0.052-.043-0.2-.168-0.125-.106-0.043-.035q-0.1-.085-0.207-0.168l-0.13-.106c-0.013-.01-0.025-0.019-0.036-0.029L465.875,388l-0.134-.106-0.028-.021-0.225-.172-0.136-.1-0.019-.014-0.26-.191-0.117-.085-0.009-.006c-0.129-.094-0.26-0.186-0.391-0.277l-0.006,0-0.071-.049-0.319-.216-0.018-.013-0.118-.077-0.266-.173-0.034-.022c-0.039-.026-0.079-0.049-0.117-0.074-0.088-.055-0.174-0.11-0.261-0.163l-0.054-.034-0.113-.067-0.248-.149-0.075-.045c-0.075-.044-0.149-0.087-0.224-0.129l-9.344,5.371c0.1,0.057.2,0.115,0.3,0.174,0.084,0.049.166,0.1,0.249,0.149l0.167,0.1,0.259,0.163,0.153,0.1,0.267,0.174,0.134,0.089c0.107,0.071.213,0.143,0.32,0.216l0.076,0.052c0.131,0.091.261,0.183,0.392,0.277l0.124,0.091c0.088,0.064.175,0.127,0.26,0.191l0.156,0.117,0.226,0.172,0.162,0.127c0.072,0.056.144,0.112,0.215,0.169l0.168,0.135,0.2,0.168c0.057,0.046.112,0.093,0.169,0.14l0.2,0.169,0.168,0.146c0.066,0.056.132,0.114,0.2,0.171l0.167,0.148,0.2,0.177,0.165,0.151c0.066,0.061.131,0.121,0.195,0.182s0.11,0.1.164,0.155,0.129,0.122.193,0.185l0.16,0.156,0.2,0.2c0.052,0.052.1,0.1,0.155,0.156l0.2,0.209,0.149,0.153,0.207,0.22c0.047,0.049.093,0.1,0.139,0.148,0.085,0.092.17,0.184,0.254,0.277l0.1,0.107q0.177,0.195.351,0.395l0.08,0.094c0.089,0.1.176,0.205,0.264,0.308l0.11,0.132c0.086,0.1.171,0.206,0.256,0.31,0.039,0.049.08,0.1,0.119,0.148,0.088,0.109.176,0.22,0.264,0.331l0.092,0.118c0.122,0.156.241,0.313,0.36,0.471,0.023,0.032.047,0.064,0.071,0.095,0.108,0.147.217,0.3,0.324,0.444l0.088,0.122c0.129,0.182.256,0.365,0.383,0.549l0.148,0.219,0.1,0.155c0.058,0.087.115,0.174,0.172,0.262,0.028,0.044.057,0.088,0.086,0.132l0.084,0.133c0.065,0.1.129,0.2,0.192,0.3,0.035,0.056.069,0.113,0.1,0.169l0.165,0.271,0.079,0.134q0.149,0.249.292,0.5c0.019,0.033.037,0.066,0.057,0.1q0.159,0.285.316,0.573c0.031,0.06.063,0.121,0.1,0.181l0.128,0.245c0.036,0.068.07,0.136,0.105,0.2s0.082,0.163.125,0.246l0.1,0.2c0.041,0.083.081,0.165,0.12,0.248s0.066,0.137.1,0.206,0.079,0.166.117,0.249l0.093,0.207c0.039,0.084.076,0.169,0.113,0.253s0.061,0.137.09,0.206c0.038,0.086.074,0.172,0.11,0.259q0.043,0.1.084,0.2c0.038,0.089.073,0.178,0.109,0.267,0.026,0.066.053,0.131,0.078,0.2,0.037,0.093.073,0.186,0.108,0.28,0.023,0.06.047,0.12,0.07,0.181,0.069,0.187.137,0.375,0.2,0.563,0.018,0.048.034,0.1,0.05,0.144,0.052,0.15.1,0.3,0.151,0.449,0.018,0.056.037,0.113,0.054,0.17,0.023,0.073.047,0.146,0.069,0.219l0.072,0.234c0.022,0.074.044,0.147,0.065,0.221s0.047,0.16.069,0.24c0.016,0.061.034,0.122,0.05,0.182,0.024,0.086.047,0.172,0.07,0.258,0.016,0.061.031,0.122,0.047,0.184s0.033,0.132.05,0.2q0.06,0.248.117,0.5l0.024,0.1c0.043,0.195.084,0.389,0.122,0.584l0.033,0.173c0.022,0.115.043,0.231,0.064,0.347,0.011,0.064.023,0.129,0.033,0.193,0.02,0.113.037,0.226,0.055,0.339,0.01,0.062.018,0.123,0.028,0.184,0.017,0.12.033,0.24,0.05,0.361l0.018,0.149c0.014,0.114.027,0.229,0.04,0.343,0,0.047.01,0.093,0.016,0.14,0.015,0.16.031,0.321,0.044,0.482,0,0.037,0,.073.008,0.11,0.009,0.123.018,0.246,0.025,0.368,0,0.075.008,0.15,0.012,0.225s0.009,0.161.011,0.241,0.005,0.151.007,0.226,0,0.16.006,0.24c0,0.148.006,0.3,0,.444,0,0.08,0,.157,0,0.236,0,0.1,0,.193,0,0.287,0,0.072-.006.143-0.008,0.214,0,0.09,0,.18-0.009.268s-0.01.162-.014,0.243-0.008.141-.012,0.209c-0.007.091-.014,0.179-0.022,0.267,0,0.055-.008.11-0.013,0.164-0.009.1-.02,0.2-0.031,0.3,0,0.038-.008.076-0.011,0.113-0.015.133-.033,0.264-0.051,0.392,0,0.036-.011.071-0.015,0.107-0.014.091-.029,0.183-0.043,0.271l-0.024.138c-0.014.077-.028,0.154-0.043,0.23-0.008.045-.017,0.09-0.026,0.134-0.015.073-.031,0.145-0.047,0.217-0.01.045-.02,0.09-0.031,0.134-0.016.07-.033,0.14-0.051,0.209-0.011.042-.02,0.083-0.032,0.125-0.019.073-.04,0.145-0.06,0.216l-0.03.1c-0.029.1-.06,0.195-0.091,0.29l-0.006.019c-0.033.1-.069,0.2-0.1,0.3-0.013.035-.025,0.069-0.039,0.1-0.023.063-.048,0.127-0.074,0.188-0.016.038-.031,0.075-0.047,0.112-0.024.057-.048,0.112-0.073,0.167s-0.036.08-.054,0.12-0.049.1-.073,0.15-0.044.087-.065,0.13l-0.072.138c-0.023.042-.046,0.084-0.07,0.125l-0.073.128-0.088.143c-0.023.038-.046,0.076-0.071,0.113s-0.066.1-.1,0.151l-0.068.1c-0.046.065-.093,0.128-0.14,0.19-0.016.02-.03,0.041-0.045,0.06-0.067.087-.136,0.172-0.206,0.255l-0.053.059c-0.062.072-.126,0.143-0.192,0.212l-0.075.079-0.061.062-0.12.118-0.061.058-0.1.094-0.1.09-0.1.086c-0.036.028-.07,0.057-0.1,0.085l-0.082.064c-0.056.044-.113,0.088-0.172,0.13l-0.084.063c-0.061.043-.122,0.086-0.185,0.128l-0.072.049c-0.052.035-.105,0.068-0.158,0.1l-0.078.049c-0.08.049-.159,0.1-0.24,0.143h0l9.344-5.371c0.081-.047.162-0.095,0.241-0.144l0.078-.049c0.053-.034.107-0.067,0.159-0.1l0.02-.013,0.052-.036c0.062-.042.124-0.085,0.184-0.128l0.085-.062c0.058-.043.116-0.087,0.172-0.131l0.052-.04a0.37,0.37,0,0,0,.029-0.024l0.1-.086,0.1-.085c0.034-.03.068-0.06,0.1-0.091s0.049-.042.073-0.065l0.03-.028,0.061-.058,0.12-.117,0.063-.063,0.037-.039,0.037-.04c0.065-.069.13-0.14,0.192-0.212l0.037-.04a0.139,0.139,0,0,1,.015-0.019c0.07-.083.14-0.168,0.207-0.255l0.007-.008,0.037-.051c0.047-.063.094-0.126,0.14-0.191a0.255,0.255,0,0,1,.021-0.028l0.047-.073c0.034-.049.068-0.1,0.1-0.15l0.029-.042c0.014-.023.028-0.048,0.043-0.071l0.086-.144c0.011-.018.022-0.035,0.032-0.053l0.042-.074,0.069-.125c0.01-.019.021-0.038,0.032-0.057l0.04-.081c0.023-.043.045-0.086,0.066-0.13l0.028-.056c0.015-.031.029-0.063,0.044-0.094s0.037-.079.055-0.12a0.511,0.511,0,0,0,.022-0.048c0.018-.039.034-0.079,0.05-0.119l0.048-.112c0-.012.01-0.023,0.015-0.035,0.02-.05.039-0.1,0.059-0.153,0.013-.035.027-0.068,0.04-0.1a0.159,0.159,0,0,1,.007-0.02c0.033-.09.065-0.182,0.1-0.275a0,0,0,0,0,0,0,0.127,0.127,0,0,1,.006-0.018c0.028-.087.057-0.174,0.083-0.263a0.268,0.268,0,0,0,.007-0.027c0.011-.035.021-0.071,0.031-0.106,0.016-.053.031-0.106,0.046-0.16,0-.018.009-0.037,0.014-0.055,0.011-.042.021-0.084,0.032-0.126s0.022-.08.031-0.122,0.014-.057.02-0.086c0.01-.045.021-0.09,0.031-0.135l0.021-.091c0.009-.041.017-0.083,0.026-0.124s0.018-.09.026-0.136c0-.021.009-0.041,0.012-0.062,0.012-.055.021-0.111,0.03-0.167s0.017-.091.025-0.138c0-.013,0-0.025.007-0.039,0.012-.076.023-0.154,0.034-0.232,0.006-.035.012-0.071,0.016-0.107a0.076,0.076,0,0,0,0-.016c0.017-.121.034-0.244,0.047-0.369a0.017,0.017,0,0,0,0-.007c0-.037.008-0.076,0.012-0.113,0.011-.094.02-0.187,0.03-0.283a0.127,0.127,0,0,1,0-.02c0-.054.009-0.109,0.013-0.164,0.006-.078.013-0.155,0.019-0.234,0-.011,0-0.022,0-0.033,0-.068.009-0.139,0.013-0.209s0.008-.136.012-0.2c0-.013,0-0.026,0-0.038,0-.088.007-0.178,0.01-0.268,0-.061,0-0.121.007-0.183v-0.031c0-.095,0-0.191,0-0.287C477.812,411,477.814,410.94,477.815,410.876Z"
                                                transform="translate(-437.469 -383.281)"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="title">
                                        General questions
                                        <svg
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 476.213 476.213"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 476.213 476.213"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="345.606,107.5 324.394,128.713 418.787,223.107 0,223.107 0,253.107 418.787,253.107 324.394,347.5 345.606,368.713 476.213,238.106 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                    </h3>
                                    <p className="subtitle">
                                        How to get started and all general staff
                                    </p>
                                </div>
                            </Link>

                            <Link
                                to="mobile"
                                spy={true}
                                smooth={true}
                                offset={-50}
                                duration={500}
                                className="col"
                            >
                                <div className="sphere red">
                                    <div className="waves">
                                        <svg
                                            className="core sphere_mobile"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={37}
                                            height={64}
                                            viewBox="0 0 37 64"
                                        >
                                            <path
                                                id="Rectangle_825_copy_13"
                                                data-name="Rectangle 825 copy 13"
                                                className="cls-1"
                                                d="M5.117,1.5H31.882A3.618,3.618,0,0,1,35.5,5.118V58.882A3.618,3.618,0,0,1,31.882,62.5H5.118A3.618,3.618,0,0,1,1.5,58.882V5.117A3.617,3.617,0,0,1,5.117,1.5Z"
                                            />
                                            <path
                                                id="Rectangle_825_copy_21"
                                                data-name="Rectangle 825 copy 21"
                                                className="cls-2"
                                                d="M838,394.346A3.272,3.272,0,0,1,841.193,391h23.614A3.272,3.272,0,0,1,868,394.346v50.307A3.272,3.272,0,0,1,864.808,448"
                                                transform="translate(-834.5 -387.5)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_20"
                                                data-name="Rectangle 825 copy 20"
                                                className="cls-3"
                                                d="M12.2,1.5H24.8a1.7,1.7,0,0,1,1.7,1.7V4.8a1.7,1.7,0,0,1-1.7,1.7H12.2a1.7,1.7,0,0,1-1.7-1.7V3.2A1.7,1.7,0,0,1,12.2,1.5Z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="title">
                                        Delibroom mobile
                                        <svg
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 476.213 476.213"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 476.213 476.213"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="345.606,107.5 324.394,128.713 418.787,223.107 0,223.107 0,253.107 418.787,253.107 324.394,347.5 345.606,368.713 476.213,238.106 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                    </h3>
                                    <p className="subtitle">
                                        Get more detailed info about mobile app
                                    </p>
                                </div>
                            </Link>

                            <Link
                                spy={true}
                                smooth={true}
                                offset={-50}
                                duration={500}
                                to="tablet"
                                className="col"
                            >
                                <div className="sphere green">
                                    <div className="waves">
                                        <svg
                                            className="core sphere_tablet"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={72}
                                            height={52}
                                            viewBox="0 0 72 52"
                                        >
                                            <path
                                                id="Rectangle_825_copy_19"
                                                data-name="Rectangle 825 copy 19"
                                                className="cls-1"
                                                d="M1281,396.268v42.467a3.262,3.262,0,0,1-3.23,3.267h-62.54a3.262,3.262,0,0,1-3.23-3.267V396.268a3.261,3.261,0,0,1,3.23-3.266h62.54A3.261,3.261,0,0,1,1281,396.268Z"
                                                transform="translate(-1210.5 -391.5)"
                                            />
                                            <path
                                                id="Rectangle_825_copy_22"
                                                data-name="Rectangle 825 copy 22"
                                                className="cls-2"
                                                d="M1215,398a3.033,3.033,0,0,1,3.05-3h57.9a3.033,3.033,0,0,1,3.05,3v38a3.033,3.033,0,0,1-3.05,3"
                                                transform="translate(-1210.5 -391.5)"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="title">
                                        Delibroom tablet
                                        <svg
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 476.213 476.213"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 476.213 476.213"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="345.606,107.5 324.394,128.713 418.787,223.107 0,223.107 0,253.107 418.787,253.107 324.394,347.5 345.606,368.713 476.213,238.106 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                    </h3>
                                    <p className="subtitle">
                                        Get more detailed info about app for
                                        tablet
                                    </p>
                                </div>
                            </Link>
                        </div>
                        <div className="group_questions">
                            <div className="group_questions_col">
                                <h3 className="title_line">
                                    Quick start guide
                                </h3>
                                <ul className="general_list">
                                    <li>
                                        <p>
                                            Download the application on a phone
                                            from the store. Phone application:{" "}
                                            <a
                                                href="https://apps.apple.com/app/id1462261055"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                App Store
                                            </a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Run the application. Register yourself and create a company - you will
                                            become an Owner of the company. If the company was already created, use
                                            the invitation link from admin inside the application, or use the link
                                            from the invitation letter on your e-mail.
                                            <br />
                                            <i>Admin phone</i> - Create a company during the registration process or
                                            by using the registration link.
                                            <br />
                                            <i>User phone</i> - Create a company user when register by using an
                                            invitation link.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Adjust workspace and meeting rooms up to your needs and taste.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Invite users to the company by using e-mail or the direct link.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Find an available meeting room right now in automatic mode or plan
                                            meetings in the planner.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Though it is possible to run the system without room displays, we
                                            recommend installing them for a better experience.
                                        </p>
                                    </li>
                                    <li className="list_none">
                                        <br />
                                        <br />
                                        <i>
                                            If you want to use room monitors,
                                            additionally perform the following:
                                        </i>
                                    </li>
                                    <li>
                                        <p>
                                            Download the application on a tablet
                                            from the store.
                                            <br />
                                            Tablet iPad application:&nbsp;
                                            <a
                                                href="https://apps.apple.com/app/id1462260974"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                App Store
                                            </a>
                                            <br />
                                            Tablet Android application:&nbsp;
                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.delibroom.tablet"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Google Play
                                            </a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            After adjusting phone application,
                                            pair admin phone with the room
                                            monitors (tablets) by using the QR
                                            code or automatically generated
                                            numbers. You will have the
                                            possibility to change the paired
                                            tablet at any moment as the pairing
                                            option is available in room
                                            settings.
                                        </p>
                                    </li>
                                </ul>
                            </div>

                            <div className="group_questions_col" id="general">
                                <h3 className="title_line">General help</h3>

                                <div className="group_questions_line">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                What platforms does Delibroom
                                                support?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Delibroom supports iOS phones and tablets (Requires iOS 12.1 or later.
                                            Compatible with iPhone, iPad), Android tablet (requires Android 8.0 or
                                            later) Android phone application will be available soon.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                What is the difference between
                                                subscription options?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            The first option is completely free and gives the possibility to operate
                                            2 meeting rooms in 1 workspace. It is granted to each Owner automatically.
                                            The second option is a monthly plan, the payment is calculated depending on
                                            the number of rooms you want to use. Yearly payment is saving some money
                                            for you if to compare with the monthly payment (5 USD per room versus 4 USD
                                            per room). Whatever is chosen, you can change or cancel the subscription
                                            plan at any moment.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                How is it possible to pay for a
                                                subscription?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Payment for subscription is
                                            performed within the application in
                                            the owner account. Fees will be
                                            charged from the card linked to
                                            Appstore account. Note that the
                                            first 14 days are free. Further fees
                                            will be charged automatically.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                What will happen if I fail to
                                                pay for the next month of
                                                subscription?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Such a situation will lead to the
                                            cancellation of the monthly paid
                                            subscription plan. The free option
                                            will be granted to this owner. It
                                            gives the possibility to use 1
                                            workspace with 2 meeting rooms. You
                                            can get back to the monthly paid
                                            subscription plan at any time in the
                                            company settings menu.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                What devices do I need to work
                                                with Delibroom?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            You will need phones for this system. Tablets are optional and can be used
                                            for a better experience (1 tablet for 1 room). Delibroom can run without
                                            room monitors, only on the phones. Chargers and connectors are necessary
                                            for the functioning of your phones and tablets. It is also possible to use
                                            special mounting devices to install room displays in right and useful
                                            places. We do not offer or make you purchase any special hardware to
                                            operate the system, your own phone is the best choice. Currently, the
                                            application supports iOS phones and tablets (Requires iOS 12.1 or later.
                                            Compatible with iPhone, iPad), Android tablet (requires Android 8.0 or
                                            later) Android phone version will appear soon.
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Where can I get applications?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            You can download applications from corresponding store, there are links on
                                            the site for quick access, or just click one of the links below:<br />
                                            iPhone application:{" "}
                                            <a
                                                href="https://apps.apple.com/app/id1462261055"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "#fff",
                                                    fontWeight: "700"
                                                }}
                                            >
                                                App Store
                                            </a><br />
                                            iPad application:{" "}
                                            <a
                                                href="https://apps.apple.com/app/id1462260974"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "#fff",
                                                    fontWeight: "700"
                                                }}
                                            >
                                                App Store{" "}
                                            </a><br />
                                            Android tablet application:{" "}
                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.delibroom.tablet"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "#fff",
                                                    fontWeight: "700"
                                                }}
                                            >
                                                Google Play{" "}
                                            </a>

                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Is it secure to use the system?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            All data shared between a phone and
                                            a tablet is transferred in encrypted
                                            form. User information such as
                                            names, e-mails, logins, and
                                            passwords is saved on remote
                                            protected servers.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Where is it better to install
                                                room displays?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Room displays should be installed
                                            near the corresponding meeting
                                            rooms. Use mounting devices to
                                            attach tablets to the wall or just
                                            put them on the tables. Ensure that
                                            the displays are safe from
                                            accidentally falling to avoid
                                            damage. Consider the availability of
                                            chargers.
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                How I can pair a phone and a
                                                tablet?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            After installation of the
                                            application on a tablet, log in and
                                            follow the instructions on the
                                            tablet. The window for QR code and
                                            number code will appear on the
                                            tablet. Just put the phone with the
                                            active QR code to the tablet’s front
                                            camera or enter the number into
                                            corresponding brackets. You can
                                            change paired devices at any time as
                                            the pairing option is available in
                                            room settings.
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Is it possible to change the
                                                name of a room?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Yes, you can change the names of the
                                            rooms and workspaces at any time by
                                            using the admin phone. Everything
                                            goes up to your taste. Additionally,
                                            it is possible to edit the company
                                            name and user name in case if
                                            something changes.{" "}
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                How can I find an available room
                                                right now?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            You don’t even have to open the
                                            planner. One button on the main
                                            screen will find available rooms
                                            “for now”. The meeting will start
                                            from the moment of reservation.{" "}
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Is it possible to prolong or
                                                shift the meeting?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Yes, you can prolong or finish at
                                            once any meeting depending on the
                                            situation. Before a meeting start,
                                            it is possible to cancel it or
                                            change starting or finishing time.
                                            The only obstacle – is the other
                                            meeting that was planned for this
                                            time.{" "}
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Where can I find settings for
                                                rooms, workspaces, and users?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            Note, that the editing of settings
                                            is available only for the admin
                                            user. You should enter your company
                                            profile to edit these settings. Tap
                                            the company icon in the left upper
                                            corner and in the next window you
                                            will see the symbol off gearwheel.
                                            It will lead you to the options menu
                                            where you can adjust settings.{" "}
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                How can I switch a workspace and
                                                what meetings will be shown in
                                                different workspaces?{" "}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            You can switch a workspace in the
                                            company settings menu. All meetings
                                            belong to the particular workspace,
                                            so only the meeting list for this
                                            workspace will be shown without any
                                            duplications.
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                What will happen if there are no
                                                available rooms according to my
                                                search settings?
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            If there are no available rooms
                                            according to particular search
                                            parameters, the system will show
                                            some suggestions. They will be
                                            marked with red letters. Suggestions
                                            will show what parameters should be
                                            changed to get the possibility to
                                            book a room for that time period. It
                                            can show some variations of time
                                            periods with initially stated
                                            criteria of the search.{" "}
                                        </p>
                                        <p>
                                            If you haven’t found the answers to
                                            your questions or have any
                                            suggestions, feel free to contact us
                                            on{" "}
                                            <a href="mailto:support@delibroom.com">
                                                support@delibroom.com
                                            </a>{" "}
                                            . We will improve your user
                                            experience.{" "}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="group_questions_col" id="mobile">
                                <h3 className="title_line">Mobile help</h3>
                                <div className="group_questions_line">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Creation and management of a
                                                company, workspaces, rooms
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <i className="t_italic">Creation</i>
                                        <p>
                                            Install the application from the
                                            store. Run it. First of all, you
                                            will have to enter registration
                                            data: the name of a created company,
                                            your name, e-mail, and password for
                                            this user. After successful
                                            registration, you will see the
                                            greeting screen. Create a workspace
                                            and the necessary number of rooms.
                                            Set the parameters of each room and
                                            give the names to distinguish them.
                                            You can change the parameters from
                                            the company settings menu at any
                                            moment. Invite users to your
                                            workspace by direct link or e-mail.
                                            The users will be shown in the form
                                            of a list where you can edit the
                                            status of each account. If you
                                            decided to use room monitors
                                            (tablets), you can pair the phone
                                            with room monitor by using the QR
                                            code or enter automatically
                                            generated code. Pairing option is
                                            available in the company settings
                                            menu. One monitor should be attached
                                            to one room.
                                        </p>

                                        <i className="t_italic">Management</i>
                                        <p>
                                            The company name can be edited in
                                            the company settings menu. The list
                                            of workspaces and rooms can be
                                            edited in the company settings menu.
                                            It is possible to change each
                                            particular name of a workspace and a
                                            room. Note that each workspace has
                                            its own list of the rooms. That
                                            means that they should be adjusted
                                            in each corresponding workspace. It
                                            is possible to edit the parameters
                                            of each particular room: its name,
                                            number of seats, available technical
                                            means. They are edited in the
                                            company settings menu, in the list
                                            of rooms. You can change the tablet
                                            that is paired to the meeting room.
                                            Perform the pairing procedure with
                                            another tablet to add it to the
                                            system.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>Admin and user rights</h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <i className="t_italic">Admin rights</i>
                                        <p>
                                            The first user that creates a
                                            company becomes an owner. It is a
                                            unique admin account. The only
                                            difference from general admin
                                            accounts - the ability to create a
                                            company and pay its fees. The total
                                            number of admin accounts for one
                                            company is unlimited.
                                            <br />
                                            All changes in the account can be
                                            performed in the company settings
                                            menu. Tap the icon of your company
                                            and then on the symbol of gearwheel
                                            to enter the settings menu. <br />
                                            The admin account is granted with
                                            all managing rights:
                                            <br />- Subscription plans and
                                            corresponding payments are regulated
                                            by the owner's smartphone.
                                            <br />- Possibility to invite users
                                            to join a company and see the
                                            meeting schedule. It is possible to
                                            manage the list of users and grant
                                            them appropriate rights. <br />
                                            - Meeting room settings changing:
                                            edit the list of technical means,
                                            the number of available seats,
                                            change the name of a workspace or a
                                            room. <br />
                                            - Changing the name of a workspace,
                                            editing the list of workspaces and rooms,
                                            deleting past meeting from the schedule.<br />
                                            Admin users can see their own
                                            meetings only or all meetings of the
                                            company. You will need an admin
                                            phone to add the room monitor to the
                                            system or change the attached
                                            monitor to another one.
                                            <br />
                                            <br />
                                            <i className="t_italic">
                                                User rights
                                            </i>
                                            Users can’t perform managing
                                            functions. They can search or
                                            schedule a meeting in a particular
                                            room, change the meeting time,
                                            prolong or cancel the meetings they
                                            participate in. The schedule is
                                            provided for each user to see
                                            available rooms and plan events
                                            beforehand. Users can use room
                                            monitors to see the list of the
                                            meetings of each particular room or
                                            see it in the form of a schedule in
                                            their phones.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Subscription plans management
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            After the initial downloading of the
                                            application to the phone, the free
                                            plan will be automatically granted
                                            to the admin user, who created a
                                            company (owner). It gives 1
                                            workspace and 2 meeting rooms for
                                            your company. In the case, if it is
                                            not enough for you, upgrade your
                                            plan to a monthly paid one,
                                            depending on the number of rooms you
                                            need. You pay only for the
                                            particular number of rooms you want
                                            to use without any additional
                                            payments.
                                            <br />
                                            It is possible to change the
                                            subscription plan by the upgrade
                                            button from the company settings
                                            menu. Choose the number of rooms you
                                            need and you will see the price for
                                            a month. The price will be lower if
                                            to choose annual payment for a set
                                            number of rooms instead of the
                                            monthly plan.
                                            <br /> Each owner account is granted
                                            with 14 days of a free trial period
                                            in the monthly paid plan. After the
                                            end of the trial period, the payment
                                            will be charged automatically.
                                            Payment is performed from the card
                                            that is linked to the Appstore
                                            account. In the case of payment
                                            failure, the company will get the
                                            basic free plan.
                                        </p>
                                    </div>
                                </div>

                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>Meeting room search </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            The search of meeting rooms that are
                                            available right now is performed by
                                            clicking on the quick search button
                                            on the main screen. If you use room
                                            monitors, you can tap the button on
                                            the tablet to start the meeting
                                            right now.
                                            <br />
                                            If you want to plan a meeting on a
                                            particular time, tap the search
                                            button and state the parameters you
                                            need for your meeting (number of
                                            seats, technical means, the
                                            available period of booking). The
                                            periodic step is 15 minutes as well
                                            as the least meeting period.
                                            <br />
                                            The system will show you possible
                                            rooms in the form of a list, or some
                                            suggestions when no such room
                                            available. The system states what
                                            parameters should be changed if
                                            something goes outside the
                                            possibilities of your premises. The
                                            initial parameters of each room
                                            should be stated by your admin.
                                        </p>
                                    </div>
                                </div>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>Meeting schedule tracking</h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <i className="t_italic">Schedule</i>
                                        <p>
                                            All scheduled meetings for the
                                            current day are shown on the phone
                                            in the form of a list. The room
                                            monitor shows the meetings in the
                                            form of a list or chart with
                                            different colors. Such an option
                                            helps to see possibilities to add a
                                            meeting in the gap between the
                                            meetings.
                                            <br />
                                            The planner can be shown in the form
                                            of a calendar to take a particular
                                            day and observe the meeting list or
                                            create a new one.
                                        </p>
                                        <i className="t_italic">
                                            After meeting started
                                        </i>
                                        <p>
                                            From the moment the meeting started,
                                            you will see in your phone the
                                            marker showing the time passed from
                                            the start and the time left. If the
                                            situation requires and there is free
                                            time in the schedule, it is possible
                                            to extend the meeting or end it
                                            earlier.
                                            <br />
                                            The colored icon on a room monitor
                                            will indicate that the meeting has
                                            started already. It will show the
                                            time left to the meeting end and in
                                            the case of any changes, will
                                            reflect those changes. Admin can end
                                            a meeting by using not only the
                                            phone but also room display. Such an
                                            option is chosen for each particular
                                            room.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="group_questions_col" id="tablet">
                                <h3 className="title_line">Tablet help</h3>
                                <div className="group_questions_line ">
                                    <div
                                        className="group_questions_head"
                                        onClick={this.show}
                                    >
                                        <svg
                                            className="group_questions_indicator"
                                            version="1.1"
                                            id="Capa_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 42 42"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 42 42"
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                            <g />
                                        </svg>
                                        <div className="group_questions_title">
                                            <h3>
                                                Working with a room monitor{" "}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="group_questions_body">
                                        <p>
                                            The system easily runs without room
                                            monitors, but it is recommended to
                                            install a room monitor for a better
                                            experience and more convenient use
                                            of the system. Adjust it near a
                                            meeting room to the wall or just
                                            place on the table, it goes up to
                                            your taste and possibilities. Ensure
                                            that the charger and appropriate
                                            cooling is available, as the monitor
                                            display does not go into sleeping
                                            mode while the application is
                                            running. Placement should be safe to
                                            avoid damage to hardware and
                                            personal health.
                                            <br />
                                            Each room monitor should be paired
                                            with the admin phone and attached to
                                            the corresponding meeting room.
                                            Pairing is performed from the
                                            company settings menu. Scan QR code
                                            - take the phone directly to the
                                            tablet’s camera, or enter
                                            automatically generated number to
                                            pair them. A paired room monitor can
                                            be changed by performing the same
                                            steps as during initial pairing, but
                                            with the other tablet.
                                            <br />
                                            The room monitor will show all the
                                            meetings planned for this room. It
                                            is possible to check any day
                                            schedule in the calendar. A schedule
                                            view can be changed from the list to
                                            the multi-colored chart for better
                                            visual perception.
                                            <br />
                                            The room monitor can be used for
                                            quick room booking for 15, 30 and 45
                                            minutes in one tap if no meetings
                                            are planned in this room for such
                                            periods.
                                            <br />A special indication shows the
                                            availability of a meeting room. The
                                            green icon shows a free room, it is
                                            possible to book it right now.
                                            Orange shows that the room can not
                                            be booked right now as there is a
                                            meeting in less than 15 minutes. The
                                            time left to the beginning is also
                                            displayed. After the meeting starts
                                            the room monitor will show it with
                                            the red icon and state the time left
                                            to the meeting finish. In case the
                                            admin stated the option of
                                            preliminary meeting end it would be
                                            possible to end a meeting
                                            beforehand. If something changes
                                            with the meeting - that event will
                                            be reflected on the monitor.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <AnyQuestions openModal={this.props.openModal} />
                    </div>
                </section>
            </>
        );
    }
}

export default HelpCenter;
